import { useDataClient } from "../hooks/client.hooks";
import { PortalInvitationResponseDTO } from "../open-api";
import { postRequest } from "../utils/api.utils";

export const useInvitations = () => useDataClient<PortalInvitationResponseDTO[]>(`/api/invitations`);

export const acceptInvitation = (portalId: string) => postRequest(`/api/invitations/${portalId}`, {});
